import { UsuarioService } from '../services/usuario.service';
import { ListadoUsuarios } from '../models/viewmodels/listadoUsuarios';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
var UsuariosComponent = /** @class */ (function () {
    function UsuariosComponent(usuarioService, router) {
        this.usuarioService = usuarioService;
        this.router = router;
        this.query = new FormControl();
        this.pagina = 0;
        this.cantidadPorPagina = 20;
        this.listado = null;
        this.paginas = 0;
        this.isLoading = true;
        this.display = false;
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.listado = new ListadoUsuarios();
        this.listado.usuarios = new Array();
    }
    UsuariosComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.obtenerUsuarios();
        this.query.valueChanges
            .debounceTime(400)
            .distinctUntilChanged()
            .subscribe(function (term) {
            if (term.length == 0) {
                _this.pagina = 0;
                _this.obtenerUsuarios();
            }
            else if (term.length > 2) {
                _this.obtenerUsuarios();
            }
        });
    };
    UsuariosComponent.prototype.obtenerUsuarios = function (paginaActual) {
        var _this = this;
        this.pagina = paginaActual == null ? 0 : paginaActual;
        this.spinner.isRunning = true;
        this.usuarioService.listado(this.pagina, this.cantidadPorPagina, this.query.value ? this.query.value : "").subscribe(function (result) {
            _this.spinner.isRunning = false;
            result.usuarios.forEach(function (u) {
                u.roles.forEach(function (r) {
                    r.name = result.roles.find(function (rol) { return rol.id == r.id; }).name;
                });
            });
            _this.listado = result;
            if (_this.listado && _this.listado.total > 0) {
                _this.paginas = Math.floor((_this.listado.total + _this.cantidadPorPagina - 1) / _this.cantidadPorPagina);
            }
        });
    };
    UsuariosComponent.prototype.anterior = function () {
        this.obtenerUsuarios(this.pagina - 1);
    };
    UsuariosComponent.prototype.siguiente = function () {
        this.obtenerUsuarios(this.pagina + 1);
    };
    UsuariosComponent.prototype.buscar = function () {
        this.pagina = 0;
        this.obtenerUsuarios();
    };
    UsuariosComponent.prototype.formatRol = function (id) {
        var rol = this.listado.roles.filter(function (x) { return x.id == id; })[0];
        if (rol) {
            return rol.name;
        }
        return null;
    };
    UsuariosComponent.prototype.showDialog = function (usuario) {
        this.usuario = usuario;
        this.display = true;
    };
    UsuariosComponent.prototype.eliminar = function () {
        var _this = this;
        this.display = false;
        this.spinner.isRunning = true;
        this.usuarioService.eliminar(this.usuario.id).subscribe(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Eliminar usuario";
            if (result.status == 204) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "El usuario " + _this.usuario.userName + " se ha eliminado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "El usuario no se ha podido eliminar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.listado.usuarios = _this.listado.usuarios.filter(function (u) {
                return u.id != _this.usuario.id;
            });
            _this.usuario = null;
            _this.spinner.isRunning = false;
        }, function (error) {
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Eliminar usuario";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "El usuario no se ha podido eliminar. Por favor vuelva a intentarlo.";
        });
    };
    UsuariosComponent.prototype.editar = function (usuario) {
        this.usuarioService.setUsuario(usuario);
        this.router.navigate(['dashboard/usuarios/editar']);
    };
    UsuariosComponent.prototype.paginate = function (event) {
        //event.first = Index of the first record
        //event.rows = Number of rows to display in new page
        //event.page = Index of the new page
        //event.pageCount = Total number of pages
        this.obtenerUsuarios(event.page);
    };
    UsuariosComponent.ctorParameters = function () { return [{ type: UsuarioService }, { type: Router }]; };
    return UsuariosComponent;
}());
export { UsuariosComponent };
//# sourceMappingURL=usuarios.component.js.map


// WEBPACK FOOTER //
// usuarios.component.js